import { Button, Form, FormProps, Input } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  createBatchPaymentAsync,
  getSinglePOForVendorAsync,
} from "../../../store/features/NP/supplier/supplierAPI";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { generateCode } from "../../../utils/string";
import CustomModal from "../../common/CustomModal";

type Props = {
  open: boolean;
  handleClose: () => void;
  data?: any;
};

export default function CreateBatchPaymentModal({
  open,
  handleClose,
  data,
}: Props) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { login } = useAppSelector((state) => state.login);
  const { postLoading, getSinglePOForVendor } = useAppSelector(
    (state) => state.supplier
  );

  const onFinish: FormProps<any>["onFinish"] = (values) => {
    const newValues = {
      ...values,
      ...data,
      suppler: login?.suppler,
      po: getSinglePOForVendor?._id,
      batchCode: generateCode("batch", {
        othersName: login?.firstName,
        join: "_",
      }).toUpperCase(),
    };

    dispatch(
      createBatchPaymentAsync({
        data: newValues,
        others: {
          callback,
        },
      })
    );
  };

  const callback = (val: string) => {
    if (val) navigate(`task-list/${val}`);
  };

  useEffect(() => {
    if (login?.role === "vendor") {
      dispatch(getSinglePOForVendorAsync());
    }
  }, [dispatch, login?.role]);

  // console.log("Login", getSinglePOForVendor);

  return (
    <CustomModal
      width={450}
      title="Add new batch"
      open={open}
      handleClose={handleClose}
    >
      <Form
        className="custom-form hide_star_mark highlight_placeholder p-6"
        layout="vertical"
        onFinish={onFinish}
        size="large"
      >
        <Form.Item
          name="batchName"
          label="Batch Name"
          rules={[
            {
              required: true,
              message: "Please enter batch name",
            },
            {
              max: 20,
              message: "Batch name maximum 20 characters",
            },
          ]}
        >
          <Input placeholder="Enter batch name" size="large" />
        </Form.Item>
        <div className="w-full justify-between flex gap-4 pt-1">
          <div className="cancel_btn block w-full">
            <Button onClick={handleClose} block size="large">
              Cancel
            </Button>
          </div>
          <Button
            type="primary"
            size="large"
            htmlType="submit"
            block
            loading={postLoading}
          >
            Create
          </Button>
        </div>
      </Form>
    </CustomModal>
  );
}
